<template>
    <div class="simple-alert container mx-auto mt-10 mb-8 bg-white shadow">
      <div class="alert-content">
        <span class="alert-title bg-yellow-600">{{ title }}</span>
        <p class="alert-message text-sm tracking-wide mt-4 sm:mt-0 sm:ml-4 text-yellow-600">{{ message }}</p>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'SimpleAlert',
    props: {
      title: {
        type: String,
        required: true
      },
      message: {
        type: String,
        required: true
      }
    }
  }
  </script>

  <style scoped>
  .simple-alert {
    padding: 10px;
  }

  .alert-content {
    display: flex;
    align-items: center;
  }

  .alert-title {
    color: #FFFFFF;
    font-weight: 500;
    font-size: 14px;
    padding: 2px 8px;
    border-radius: 25px;
  }

  .alert-message {
    font-size: 14px;
  }
  </style>



// WEBPACK FOOTER //
// src/components/common/ui/simpleAlert.vue